var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKycOffline = function SvgKycOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 118,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__a)",
    d: "M.546 51.475c0 28.108 22.867 50.975 50.975 50.975V37.764z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__b)",
    d: "M51.521 37.764v64.686c28.108 0 50.975-22.867 50.975-50.975z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__c)",
    d: "M102.496 51.475C102.496 23.367 79.629.5 51.521.5v50.975z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__d)",
    d: "M51.521.5C23.413.5.546 23.367.546 51.475h50.975z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__e)",
    d: "M77.009 51.475c0 28.108-11.434 50.975-25.488 50.975l-13.71-61.258h26.454z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__f)",
    d: "M51.521.5C65.575.5 77.01 23.367 77.01 51.475H41.238z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__g)",
    d: "M26.034 51.475c0 28.108 11.433 50.975 25.487 50.975V51.475L38.777 41.192z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__h)",
    d: "M51.521.5C37.467.5 26.034 23.367 26.034 51.475H51.52z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__i)",
    d: "M111.973 101.1 86.477 56.941c-2.104-3.644-5.786-5.466-9.468-5.466L63.298 84.488l13.71 33.012h25.497c8.416 0 13.676-9.111 9.468-16.4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kycOffline_svg__j)",
    d: "M67.54 56.941 42.044 101.1c-4.208 7.289 1.052 16.4 9.469 16.4h25.496V51.475c-3.683 0-7.365 1.822-9.469 5.466"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E6E6",
    d: "M80.437 106.357h-3.428l-1.714-3.427 1.714-3.428h3.427z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.581 99.502h3.428v6.855H73.58z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E6E6",
    d: "M80.437 92.647h-3.428l-1.714-11.972 1.714-11.971h3.427z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.581 68.704h3.428v23.943H73.58z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycOffline_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-43.04187 58.58368 -51.98871 -38.1965 47.643 41.975)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycOffline_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(126.306 38.686 45.946)scale(72.6957 64.5122)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycOffline_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.994 48.479 23.352)scale(63.1186 58.5519)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycOffline_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.995 22.991 12.268)scale(63.1187 58.552)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycOffline_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-33.09836 55.47898 -45.39946 -27.085 74.026 45.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D3E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycOffline_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(123.195 36.111 21.995)scale(55.1688 47.0083)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycOffline_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(111.202 9.324 39.564)scale(59.507 37.3169)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "kycOffline_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-21.52084 46.16632 -32.8809 -15.32773 49.582 3.818)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D3E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kycOffline_svg__i",
    x1: 88.376,
    x2: 88.376,
    y1: 46.377,
    y2: 141.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kycOffline_svg__j",
    x1: 58.786,
    x2: 58.786,
    y1: 46.377,
    y2: 141.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })))));
};
export default SvgKycOffline;